var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-checkbox',_vm._g({class:_vm.customClass,attrs:{"value":_vm.value,"size":"lg","dense":""}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }